var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2498 23.4991C5.04606 23.4991 -0.000732422 18.4523 -0.000732422 12.2486C-0.000732422 6.04484 5.04606 0.998047 11.2498 0.998047C17.4535 0.998047 22.5003 6.04484 22.5003 12.2486C22.5003 15.0141 21.4973 17.5498 19.8361 19.5109L29.725 29.3998C30.0915 29.7664 30.0915 30.3589 29.725 30.7255C29.5421 30.9083 29.3021 31.0002 29.0621 31.0002C28.8221 31.0002 28.5821 30.9083 28.3993 30.7255L18.5102 20.8365C16.5494 22.4968 14.0145 23.4991 11.2498 23.4991ZM11.2498 2.87315C6.08019 2.87315 1.87437 7.07897 1.87437 12.2486C1.87437 17.4182 6.08019 21.624 11.2498 21.624C16.4194 21.624 20.6252 17.4182 20.6252 12.2486C20.6252 7.07897 16.4194 2.87315 11.2498 2.87315Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5069_46741",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 31,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2498 23.4991C5.04606 23.4991 -0.000732422 18.4523 -0.000732422 12.2486C-0.000732422 6.04484 5.04606 0.998047 11.2498 0.998047C17.4535 0.998047 22.5003 6.04484 22.5003 12.2486C22.5003 15.0141 21.4973 17.5498 19.8361 19.5109L29.725 29.3998C30.0915 29.7664 30.0915 30.3589 29.725 30.7255C29.5421 30.9083 29.3021 31.0002 29.0621 31.0002C28.8221 31.0002 28.5821 30.9083 28.3993 30.7255L18.5102 20.8365C16.5494 22.4968 14.0145 23.4991 11.2498 23.4991ZM11.2498 2.87315C6.08019 2.87315 1.87437 7.07897 1.87437 12.2486C1.87437 17.4182 6.08019 21.624 11.2498 21.624C16.4194 21.624 20.6252 17.4182 20.6252 12.2486C20.6252 7.07897 16.4194 2.87315 11.2498 2.87315Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5069_46741)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.000976562,
    y: 1,
    width: 30.0016,
    height: 30.0016,
    fill: "#9EA0A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/search-grey.de75a2bcc4e15716b304f44158efd99d.svg";
export { ForwardRef as ReactComponent };